@for (item of placeholderItems; track $index) {
<div class="flex items-center gap-5 h-12">
  <div
    class="animate-pulse bg-[#DDDEE0] max-w-25 w-full h-25 rounded-full"
  ></div>
  <div class="animate-pulse bg-[#DDDEE0] w-full h-6"></div>
</div>
<div class="flex flex-col gap-4">
  @for (subItem of placeholderSubItems; track $index) {
  <div class="flex gap-5">
    <div class="animate-pulse bg-[#DDDEE0] w-full h-6"></div>
    <div class="animate-pulse bg-[#DDDEE0] w-6 h-6"></div>
  </div>
  }
</div>
}
